import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="md:col-span-2">
              <h3 className="text-2xl font-light text-arctic-blue tracking-wider mb-4">
                ARCTIC ATLAS
              </h3>
              <p className="text-gray-600 font-light max-w-sm">
                {t('footer.tagline')}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm uppercase tracking-wider text-gray-500 mb-4">{t('footer.quickLinks')}</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#about" className="text-gray-600 hover:text-arctic-blue transition-colors font-light text-sm">
                    {t('footer.about')}
                  </a>
                </li>
                <li>
                  <a href="#products" className="text-gray-600 hover:text-arctic-blue transition-colors font-light text-sm">
                    {t('footer.products')}
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-600 hover:text-arctic-blue transition-colors font-light text-sm">
                    {t('footer.contact')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm uppercase tracking-wider text-gray-500 mb-4">{t('footer.contact')}</h4>
              <ul className="space-y-2 text-sm font-light text-gray-600">
                <li>
                  <a href="mailto:info@arcticatlas.eu" className="hover:text-arctic-blue transition-colors">
                    info@arcticatlas.eu
                  </a>
                </li>
                <li>+358401515505</li>
                <li>{t('footer.location')}</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-100 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm font-light text-gray-500">
              © {currentYear} Arctic Atlas Oy. {t('footer.rights')}
            </p>
            
            {/* Minimal social links */}
            <div className="flex space-x-6">
              <motion.a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-arctic-blue transition-colors"
                whileHover={{ y: -2 }}
                aria-label="LinkedIn"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </motion.a>
              
              <motion.a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-arctic-blue transition-colors"
                whileHover={{ y: -2 }}
                aria-label="Facebook"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;